import { render, staticRenderFns } from "./journey.vue?vue&type=template&id=1b4b5f62&scoped=true&"
import script from "./journey.vue?vue&type=script&lang=js&"
export * from "./journey.vue?vue&type=script&lang=js&"
import style0 from "./journey.vue?vue&type=style&index=0&id=1b4b5f62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b5f62",
  null
  
)

export default component.exports